<template>
  <VueFinalModal
    class="dialog-modal"
    content-class="dialog-modal-content"
    content-transition="vfm-slide-up"
  >
    <div class="dialog-content">
      <span>{{ props.text }}</span>
      <div class="buttons">
        <button @click="() => emit('close')">Cancel</button>
        <button class="accent" @click="() => emit('confirm')">{{ props.confirmText }}</button>
      </div>
    </div>
  </VueFinalModal>
</template>

<script setup lang="ts">
import { VueFinalModal } from "vue-final-modal";

const emit = defineEmits(["confirm", "close"]);

const props = defineProps({
  text: String,
  confirmText: String
});
</script>

<style scoped lang="scss">
.dialog-content {
  margin: 25px;
}
</style>
<style lang="scss">
.dialog-modal {
  justify-content: flex-end;
  align-items: flex-start;
}
.dialog-modal-content {
  margin-top: 70px;
  margin-right: 30px;
  background: var(--foreground-white, #fff);
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: -8px;
  border-radius: 12px;
  width: 400px;
  border-top: solid 5px var(--status-error, #ef3a34);
  /* elevation/5 */
  box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.08), 0px 2px 8px 0px rgba(0, 0, 0, 0.04),
    0px 16px 24px 0px rgba(0, 0, 0, 0.12);
}
</style>
